import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./mealschargedbysubsidy.component.html",
})
export class MealsChargedBySubsidyComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		MealSubsidyTypeID: -1,
		startDate: new Date(),
		endDate: new Date(),
		MealID: -1,
		ImageLogo: "",
	};
	schoolList: any = [];

	mealList: any = [];
	mealSubsidyList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ReportID: number = 263;

	subscription: any;

	ngOnInit() {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(263);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
					this.report.SchoolID = this.schoolList[0].SchoolID;
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;

		this.MealList();
		this.MealSubsidyList();
		this.loadLogolist();
	}

	private MealList() {
		this.report.MealID = -1;
		var result = this.reportService.MealGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.mealList = response;

				this.mealList.unshift({
					MealID: -1,
					MealName: "All Meals",
				});

				this.report.MealID = this.mealList[0].MealID;
			},
			(error) => {}
		);
	}

	private MealSubsidyList() {
		this.report.MealSubsidyTypeID = -1;

		var result = this.reportService.MealSubsidyGetList();
		result.subscribe(
			(response) => {
				this.mealSubsidyList = response;

				this.mealSubsidyList.unshift({
					MealSubsidyTypeID: -1,
					MealSubsidyTypeDesc: "All Meal Subsidies",
				});

				this.report.MealSubsidyTypeID = this.mealSubsidyList[0].MealSubsidyTypeID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 263;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += this.report.SchoolID + "|SchoolID";

		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.endDate).format("MM/DD/YYYY");

		strParam += "," + startDate + "|StartDate";
		strParam += "," + endDate + "|EndDate";
		strParam += "," + this.report.MealID + "|MealID";
		strParam += "," + this.report.MealSubsidyTypeID + "|MealSubsidyTypeID";
		// strParam += "," + vm.searchOptions.sortBy + "|ORDERBY"
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
